import Vue from 'vue'
import axios from 'axios';
import numeral from 'numeral';
import moment from 'moment';
import CryptoJS from "crypto-js";
import api from './models/coreapi';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
export default {
    install (Vue) {
        Vue.prototype.$base = function(){
          return api.base();
        };

        Vue.prototype.$api = function(){
          let lcstorage = localStorage.getItem('jwt');
          var token = lcstorage!= null? CryptoJS.AES.decrypt(lcstorage, '2693ef35-1474-40f9-93ec-2b18c8059014').toString(CryptoJS.enc.Utf8): "";
          return axios.create({
            baseURL: api.base(),
            headers: { Authorization: 'Bearer ' +  token }
          });
        };

        Vue.prototype.$isValid = (res) => {
          return api.isValid(res);
        }

        Vue.prototype.$now = function(){
          return moment();
        };

        Vue.prototype.$format = function(value, format){
          return moment(value).format(format);
        };

        Vue.prototype.$formats = function(value){
          return moment(value).format('DD-MMM-YYYY');
        };

        Vue.prototype.$number = function(value, format){
          return numeral(value).format(format);
        };

        Vue.prototype.$money = function(value){
          return numeral(value).format('$0,0.[0000]');
        };

        Vue.prototype.$dollar = function(value){
          return numeral(value).format('$0,0.[0000]');
        };

        Vue.prototype.$dollar2 = function(value){
          if(value != 0 && value != 0.00)
            return numeral(value).format('$0,0.[0000]');
        };

        Vue.prototype.$startOfMonth = () => {
          return moment().startOf('month').format('YYYY-MM-DD');
        }

        Vue.prototype.$endOfMonth = () => {
          return moment().endOf('month').format('YYYY-MM-DD');
        }

        Vue.prototype.$isKeyNumber = function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
        }

        Vue.prototype.$tokh = (value) => {
          var arr_num = ['០', '១', '២', '៣', '៤', '៥', '៦', '៧', '៨', '៩'];
          var result = '';
          for (var index = 0; index < value.length; index++) {
              var i = value[index];
              if (!isNaN(parseFloat(i)) && isFinite(i)) {
                  result = result + arr_num[i];
              } else {
                  result = result + value[index];
              }
          }
          return result;
        }

        Vue.prototype.$day = (day_name) => {
          var arr_day = {
              'Mon': 'ច័ន្ទ',
              'Tue': 'អង្គារ៍',
              'Wed': 'ពុធ',
              'Thu': 'ព្រហ',
              'Fri': 'សុក្រ',
              'Sat': 'សៅរ៍',
              'Sun': 'អាទិត្យ',
          };
          return arr_day[day_name];
        }

        Vue.prototype.$month = (month) => {
          let months = [ "មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្តដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា","ធ្នូ"];
          let result = '';
          if (month > 0 && month <= 12)
          {
              result = months[month];
          }

          return result;
        }

        Vue.prototype.$statusLabel = (status) => {
          var success = ['Posted','In Payment','To Invoice','Paid','Done'];
          let dangers = ['Over', 'Not Paid'];
          if(status == 'Draft' || status=='Pending') return '<span class="badge badge-info">'+status+'</span>';
          else if(status == 'Quotation') return '<span class="badge badge-primary">'+status+'</span>';
          else if(dangers.includes(status)) return '<span class="badge badge-danger">'+status+'</span>';
          else if(success.includes(status)) return '<span class="badge badge-success">'+status+'</span>';
          else if(status == 'Partially Paid' || status == 'Nothing To Invoice') return '<span class="badge badge-warning">'+status+'</span>';
        }

        Vue.prototype.$years = () => {
          var result = [];
          var syear = 2025;
          var cyear = new Date().getFullYear();
          var n = cyear - syear;
          if(n > 0){
            for(var i = 0; i <= n; i++){
              result.push(syear + i);
            }
          }else result.push(syear);

          return result;
        }
    }
}
